export const subscriptions = (state) => {
    return state.subscriptions;
}

export const options = (state) => {
    return state.options;
}